import React, { useState } from "react";
import Menu from "./Menu/index";
import "./header.css";
import SideDrawer from "./Menu/SideDrawer/SideDrawer";
import Backdrop from "../Backdrop/Backdrop";

export default function Header(props) {
  const [isOpen, setIsOpen] = useState(false);

  const drawerToggleOnClick = () => {
    setIsOpen(!isOpen);
  };

  const backdropClicked = () => {
    setIsOpen(false);
  };

  return (
    <header className="headerTop">
      <Menu drawerToggleOnClick={drawerToggleOnClick} />
      <SideDrawer drawerToggleOnClick={drawerToggleOnClick} isOpen={isOpen} />
      {isOpen && <Backdrop backdropClicked={backdropClicked} />}
    </header>
  );
}
